<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style="enable-background:new 0 0 512 512;"
    xml:space="preserve"
    width="512px"
    height="512px"
    class="hovered-paths"
  >
    <g>
      <circle
        style="fill:#000000"
        cx="256"
        cy="256"
        r="256"
        data-original="#EF72AD"
        class
        data-old_color="#EF72AD"
      />
      <path
        style="fill:#000000"
        d="M256,0c-11.317,0-22.461,0.744-33.391,2.167C348.216,18.53,445.217,125.933,445.217,256  s-97.002,237.47-222.609,253.833C233.539,511.256,244.683,512,256,512c141.385,0,256-114.616,256-256S397.385,0,256,0z"
        data-original="#EE539E"
        class
        data-old_color="#EE539E"
      />
      <g>
        <path
          style="fill:#FFFFFF"
          d="M350.84,91.826H161.16c-38.231,0-69.334,31.103-69.334,69.334v189.682   c0,38.231,31.103,69.334,69.334,69.334h189.682c38.231,0,69.334-31.103,69.334-69.334V161.16   C420.174,122.929,389.071,91.826,350.84,91.826z M403.478,350.84c0,29.025-23.613,52.638-52.638,52.638H161.16   c-29.025,0-52.638-23.613-52.638-52.638V161.16c0-29.025,23.613-52.638,52.638-52.638h189.682   c29.025,0,52.638,23.613,52.638,52.638v189.68H403.478z"
          data-original="#FFFFFF"
          class="active-path"
          data-old_color="#FFFFFF"
        />
        <path
          style="fill:#FFFFFF"
          d="M256,169.739c-47.565,0-86.261,38.696-86.261,86.261s38.696,86.261,86.261,86.261   s86.261-38.696,86.261-86.261S303.565,169.739,256,169.739z M256,325.565c-38.358,0-69.565-31.208-69.565-69.565   s31.208-69.565,69.565-69.565s69.565,31.208,69.565,69.565S294.358,325.565,256,325.565z"
          data-original="#FFFFFF"
          class="active-path"
          data-old_color="#FFFFFF"
        />
        <circle
          style="fill:#FFFFFF"
          cx="345.043"
          cy="155.826"
          r="22.261"
          data-original="#FFFFFF"
          class="active-path"
          data-old_color="#FFFFFF"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'Instagram'
}
</script>
